import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const loaderFn = /* @__PURE__ */ createRecipe('loader', {}, [])

const loaderVariantMap = {}

const loaderVariantKeys = Object.keys(loaderVariantMap)

export const loader = /* @__PURE__ */ Object.assign(memo(loaderFn.recipeFn), {
  __recipe__: true,
  __name__: 'loader',
  __getCompoundVariantCss__: loaderFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: loaderVariantKeys,
  variantMap: loaderVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, loaderVariantKeys)
  },
  getVariantProps: loaderFn.getVariantProps,
})